import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var TopTermsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query topTermsQuery($termsSize: Int) {\n    topTerms(topTermsRequest: { size: $termsSize }) {\n      label\n      terms\n    }\n  }\n"])));
export default TopTermsQuery;